module.exports = __webpack_public_path__ + "exo-latin-800.1ae3922dda8cca45438a.woff2";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-800.woff2
// module id = ../../../../typeface-exo/files/exo-latin-800.woff2
// module chunks = styles